import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=2a325576&scoped=true"
import script from "./Downloads.vue?vue&type=script&lang=ts"
export * from "./Downloads.vue?vue&type=script&lang=ts"
import style0 from "./Downloads.vue?vue&type=style&index=0&id=2a325576&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a325576",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a325576')) {
      api.createRecord('2a325576', component.options)
    } else {
      api.reload('2a325576', component.options)
    }
    module.hot.accept("./Downloads.vue?vue&type=template&id=2a325576&scoped=true", function () {
      api.rerender('2a325576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/Downloads.vue"
export default component.exports